import React from 'react';
import PropTypes from 'prop-types';
import { MedpassHeroIllustration } from 'components/registration-shared/RegistrationIllustrations';
import PRODUCT_FEATURES from 'components/registration-shared/productFeatures';
import RegistrationLayout from './RegistrationLayout';

/**
 * The sign-in family of pages — sign in, forgot password, change password and
 * reset password — on the same split layout as /register, with a narrow form
 * card. One brand panel for all of them: today's medpass, and on the sign-in
 * page itself, what MapYourMeds does — with the medpass playing through the
 * day on a loop.
 */
const SignInLayout = ({ showFeatures = false, footer = null, children }) => (
  <RegistrationLayout
    className={showFeatures ? 'is-login' : undefined}
    title={
      <>
        Medication management
        <br />
        simplified.
      </>
    }
    hero={<MedpassHeroIllustration live={showFeatures} />}
    features={showFeatures ? PRODUCT_FEATURES : []}
    size="narrow"
    footer={footer}
  >
    {children}
  </RegistrationLayout>
);

SignInLayout.propTypes = {
  showFeatures: PropTypes.bool,
  footer: PropTypes.node,
  children: PropTypes.node.isRequired
};

export default SignInLayout;
